export const MIN_HEIGHT = "300px";
export const EXPORT_LEGEND_WIDTH = 200;
export const EXPORT_TITLE_HEIGHT = 44;
export const TIMESERIES_X_AXIS_TICK_REQUIRED_SPACE = 15;
export const X_AXIS_LABEL_LINE_HEIGHT = 18;
export const Y_AXIS_LABEL_SPACE = 15;
export const X_AXIS_LABEL_GAP = 60;
